import React from 'react';
import { IconCaretDownFill, IconCaretRightFill } from '@awp/components/awpIcons';

const pstyle = {
  cursor: 'pointer',
};
function AwpIsExpanded({ collapsed, ...props }) {
  return (
    <div {...props}>{collapsed ? <IconCaretRightFill style={pstyle} /> : <IconCaretDownFill style={pstyle} />}</div>
  );
}

export default AwpIsExpanded;
